import React, { useRef } from "react";
import { FaSignOutAlt } from "react-icons/fa";

import { Avatar, Button, Modal } from "../../ui";

type Props = {
  open: boolean;
  firstName?: string;
  lastName?: string;
  role?: string;
  onCancel: () => void;
  onConfirm: () => void;
};

const LogoutDialog: React.FC<Props> = ({
  open,
  firstName,
  lastName,
  role,
  onCancel,
  onConfirm,
}) => {
  const cancelRef = useRef<HTMLButtonElement>(null);

  const fullName = [firstName, lastName].filter(Boolean).join(" ") || "—";
  const prettyRole = (role ?? "").replace(/_/g, " ").toLowerCase();

  return (
    <Modal
      open={open}
      onClose={onCancel}
      size="sm"
      initialFocusRef={cancelRef}
      title="Sign out of your account?"
      description="You’ll need to sign back in to keep working. Any unsaved changes will be lost."
      footer={
        <>
          <Button ref={cancelRef} variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            <FaSignOutAlt className="h-3.5 w-3.5" />
            Sign out
          </Button>
        </>
      }
    >
      <div className="flex items-center gap-3 rounded-xl border border-gray-200 bg-gray-50/70 px-3 py-3">
        <Avatar firstName={firstName} lastName={lastName} size="md" />
        <div className="flex min-w-0 flex-col leading-tight">
          <span
            className="truncate text-[13px] font-medium text-gray-900"
            title={fullName}
          >
            {fullName}
          </span>
          <span className="truncate text-[11px] capitalize text-gray-500">
            {prettyRole || "member"}
          </span>
        </div>
      </div>

      <p className="mt-3 flex items-center gap-1.5 text-[11px] text-gray-500">
        Press
        <kbd className="rounded-md border border-gray-200 bg-white px-1.5 py-[1px] text-[10px] font-semibold text-gray-600 shadow-sm">
          Esc
        </kbd>
        to cancel.
      </p>
    </Modal>
  );
};

export default LogoutDialog;
